import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { getDomainConfig } from './services/domainService';

import { I18nProvider, useApp } from './providers';
import { getTheme } from './themes';
import {
  loadGoogleAnalytics,
  loadHotjar,
  loadFacebookPixel,
} from './utils/cookiesLoaders';
import { initialize as initializeMautic } from './utils/Mautic.util';
import { getCookiePrefs } from './utils/cookieConsent';
import CookieBanner from './components/Cookies/CookieBanner';
import Routes from './views/Routes';

const App = () => {
  const { themeName } = useApp();
  const { locale: language } = getDomainConfig();
  const [cookiePrefs, setCookiePrefs] = React.useState(null);

  useEffect(() => {
    const prefs = getCookiePrefs();
    setCookiePrefs(prefs);
  }, []);

  useEffect(() => {
    if (!cookiePrefs) return;

    if (cookiePrefs.analytics) {
      if (process.env.REACT_APP_GA_ID && !window.gtag) {
        loadGoogleAnalytics(process.env.REACT_APP_GA_ID);
      }

      const hotjarId = process.env.REACT_APP_HOTJAR_ID;

      if (hotjarId && !isNaN(Number(hotjarId)) && !window.hj) {
        loadHotjar(hotjarId, process.env.REACT_APP_HOTJAR_SV);
      }
    } else {
      const gaId = process.env.REACT_APP_GA_ID;
      if (gaId) {
        window[`ga-disable-${gaId}`] = true;
      }
      if (window.hj) {
        window.hj('consent', false);
      }
    }
    if (cookiePrefs.marketing) {
      if (process.env.REACT_APP_PIXEL_ID && !window.fbq) {
        loadFacebookPixel(process.env.REACT_APP_PIXEL_ID);
      }

      if (!window._mauticInitialized) {
        initializeMautic();
        window._mauticInitialized = true;
      }
    } else {
      if (window.fbq) {
        window.fbq('consent', 'revoke');
      }
      window._mauticInitialized = false;
    }
  }, [cookiePrefs]);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <ThemeProvider theme={getTheme(themeName)}>
      <I18nProvider locale={language}>
        <Routes />
        <CookieBanner onChangePrefs={setCookiePrefs} />
      </I18nProvider>
    </ThemeProvider>
  );
};

export default App;
